import { firebase, db } from '../firebase';

export default {
  // initial state
  state: {},
  effects: (dispatch) => ({
    // TODO: remove 'propiedad1'
    async fetchAllWhereImAdminOrCustodian() {
      const adminList = (
        await db
          .child(`userHasPropiedades/${firebase.auth().currentUser.uid}`)
          .orderByChild('type')
          .equalTo('admin')
          .once('value')
      ).val();
      const custodianList = (
        await db
          .child(`userHasPropiedades/${firebase.auth().currentUser.uid}`)
          .orderByChild('type')
          .equalTo('custodian')
          .once('value')
      ).val();
      const managedList = [
        ...Object.values(adminList || []),
        ...Object.values(custodianList || [])
      ];
      const payload = { managedList };
      if (managedList.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        payload.selectedProperty = managedList[0];
        dispatch.property.select(managedList[0]);
      }
      dispatch.property.genericReducer(payload);
    },
    async select(selectedProperty, rootState) {
      console.log({ selectedProperty });
      const { uid } = firebase.auth().currentUser;
      const currentMember = (
        await db.child(`propiedadHasUsers/${selectedProperty.id}/${uid}`).once('value')
      ).val();
      const currentRole = currentMember?.type;
      const managedRoles = ['guest', 'owner'];
      if (currentRole && currentRole === 'admin') {
        managedRoles.push('custodian');
      }
      dispatch.property.genericReducer({ selectedProperty, currentRole, managedRoles });
    },
    async fetchMembersByPropertyId(propertyId) {
      let members = (await db.child(`propiedadHasUsers/${propertyId}`).once('value')).val();
      const currentRole = members[`${firebase.auth().currentUser.uid}`]?.type;
      const managedRoles = ['guest', 'owner'];
      if (currentRole && currentRole === 'admin') {
        managedRoles.push('custodian');
      }
      members = Object.values(members || []);
      members = members.filter((m) => m.type && managedRoles.some((r) => r === m.type));
      // dispatch.property.genericReducer({ members, currentRole, managedRoles });
      dispatch.property.genericReducer({ members });
    },
    async saveMember(memberFormInfo, rootState) {
      const { selectedProperty } = rootState.property;
      const { members } = rootState.property;

      console.log({ memberFormInfo });

      let user = (
        await db.child('users').orderByChild('email').equalTo(memberFormInfo.email).once('value')
      ).val();

      if (!user) {
        throw Error('No se encontró usuario');
      }
      user = { ...Object.values(user)[0], id: Object.keys(user)[0] };

      const userIsMemberAlready = (
        await db.child(`propiedadHasUsers/${selectedProperty.id}/${user.id}`).once('value')
      ).exists();

      if (userIsMemberAlready) {
        throw Error(`${user.firstName} ${user.lastName} ya es miembro de esta propiedad`);
      }

      const propertyHasUserData = {
        email: user.email,
        id: user.id,
        name: `${user.firstName} ${user.lastName}`,
        type: memberFormInfo.role,
        userHasChapa: false,
        dptoNumber: memberFormInfo.dptoNumber
      };

      const userHasPropertyData = {
        ...propertyHasUserData,
        id: selectedProperty.id,
        name: selectedProperty.name
      };
      delete userHasPropertyData.email;

      console.log({ propertyHasUserData, userHasPropertyData });

      const updates = {};
      updates[`propiedadHasUsers/${selectedProperty.id}/${user.id}`] = propertyHasUserData;
      updates[`userHasPropiedades/${user.id}/${selectedProperty.id}`] = userHasPropertyData;

      const error = await new Promise((resolve) => {
        firebase
          .database()
          .ref()
          .update(updates, (error) => {
            resolve(error);
          });
      });
      if (error) {
        throw Error('Ocurrió un error con el servidor. No se pudo agregar el usuario.');
      }
      dispatch.property.fetchMembersByPropertyId(selectedProperty.id);
    },
    async removeMember(memberId, rootState) {
      const { selectedProperty } = rootState.property;
      const { members } = rootState.property;

      const updates = {};
      updates[`propiedadHasUsers/${selectedProperty.id}/${memberId}`] = null;
      updates[`userHasPropiedades/${memberId}/${selectedProperty.id}`] = null;

      const error = await new Promise((resolve) => {
        firebase
          .database()
          .ref()
          .update(updates, (error) => {
            resolve(error);
          });
      });
      if (error) {
        throw Error('Ocurrió un error con el servidor. No se pudo eliminar el usuario.');
      }
      dispatch.property.fetchMembersByPropertyId(selectedProperty.id);
    }
  }),
  reducers: {
    genericReducer(state, payload) {
      return {
        ...state,
        ...payload
      };
    }
  }
};
